import {URMRole, URMRoles} from "@/models/dto/userRoleManagement";

// This list is in order of precedence
export const teamRoles: URMRole[] = [URMRoles.AccountAdmin, URMRoles.AccountAuthorizedUser]

/**
 * Function will search for the requested roles in provided order and return the first one found
 * @param teamRoles - map of customerId to array of role keys
 * @param customerId - customer id to search for
 * @param requestedRoles - array of URMRole objects in order of precedence
 */
export const findBestRoleForCustomerInTeam = (teamRoles: Record<number, string[]>, customerId: number, requestedRoles: Array<URMRole>): URMRole | null => {
  const roles = teamRoles[customerId] || []

  return findBestRoleForCustomer(roles, requestedRoles)
}

/**
 * Function will search for the requested roles in provided order and return the first one found
 * @param roleKeys - list of customer role keys to search for
 * @param requestedRoles - array of URMRole objects in order of precedence
 */
export const findBestRoleForCustomer = (roleKeys: string[], requestedRoles: Array<URMRole>): URMRole | null => {
  for  (const requestedRole of requestedRoles) {
    for (const roleKey of roleKeys) {
      if (requestedRole.key === roleKey) {
        return requestedRole
      }
    }
  }

  return null
}

export const noTeamRoleDisplayText = 'User'


const roleKeyToLabelMap: Map<string, string> = new Map([
  [URMRoles.AccountAdmin.key, URMRoles.AccountAdmin.label],
  [URMRoles.AccountAuthorizedUser.key, URMRoles.AccountAuthorizedUser.label],
  [URMRoles.TripAuthorizedUser.key, URMRoles.TripAuthorizedUser.label],
  [URMRoles.TripViewOnly.key, URMRoles.TripViewOnly.label],
  [URMRoles.TripEditor.key, URMRoles.TripEditor.label],
  [URMRoles.TripContact.key, URMRoles.TripContact.label],
  [URMRoles.TripBookingUser.key, URMRoles.TripBookingUser.label],
])

export const getRoleLabelByKey = (roleKey: string): string | undefined => {
  return roleKeyToLabelMap.get(roleKey)
}
